import Constants from '../DataManagement/Constants';

const initialState = { screen: Constants.SCREEN_STATES.loading };

/**
 * Stores information of the current screen State. (Standard/Onboarding/etc)
 * @param {*} state
 * @param {*} action
 */
const screenStateReducer = (state = initialState, { gameId, type, payload }) => {
  if (type === 'SELECT_ACTIVITY' && payload.activity === Constants.GAME_ID) {
    return initialState;
  }
  if (gameId !== Constants.GAME_ID) {
    return state;
  }
  switch (type) {
    case Constants.REDUX_ACTIONS.UPDATE_SCREEN_STATE:
      return {
        ...state,
        screen: payload,
      };

    default:
      return state;
  }
};

export default screenStateReducer;
